module.exports = __webpack_public_path__ + "static/media/contato.17dfff64.svg";